/* Importing the PropTypes module from the prop-types package. */
import PropTypes from 'prop-types';

/* Importing the components from the Material UI library. */
import { InputAdornment, Grid, Stack, TextField, Typography } from '@mui/material';

PatientSectionParameterSettings.propTypes = {
  pagePatient: PropTypes.object,
};

/* Exporting the PatientSectionParameterSettings function. */
export default function PatientSectionParameterSettings(props) {
  /* Destructuring the props object and assigning the isEdit property to a variable of the same name. */
  const { pagePatient } = props;

  return (
    <form autoComplete="off">
      <Grid item xs={12}>
        <Typography variant="subtitle1" sx={{ pb: 1 }}>
          Lifeline Patient Configuration
        </Typography>
      </Grid>
      <Grid container item xs={12} spacing={2}>
        <Grid container item xs={12} md={12} spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">Blood Pressure</Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Stack sx={{ pb: 1 }}>
              <Typography variant="subtitle2">Systolic</Typography>
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-bp_systolic_upper']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">mmHg</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-bp_systolic_lower']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">mmHg</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack sx={{ pb: 1 }}>
              <Typography variant="subtitle2">Diastolic</Typography>
            </Stack>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-bp_diastolic_upper']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">mmHg</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-bp_diastolic_lower']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">mmHg</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
        </Grid>

        <Grid container item xs={12} md={12} spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              Heart Rate
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-heartrate_upper_bpm']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">BPM</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-heartrate_lower_bpm']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">BPM</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              Pulse Rate
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-pulserate_upper_bpm']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">BPM</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-pulserate_lower_bpm']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">BPM</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
        </Grid>

        <Grid container item xs={12} md={12} spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              Oxygen Saturation
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-oxygen_upper_saturation']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-oxygen_lower_saturation']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              Respiratory Rate
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-respiratory_upper_rpm']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">RPM</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-respiratory_lower_rpm']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">RPM</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
        </Grid>

        <Grid container item xs={12} md={12} spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              Temperature
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Upper"
                value={pagePatient['patient-lifeline-config-temperature_upper']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">&deg;C</InputAdornment>,
                }}
              />

              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Lower"
                value={pagePatient['patient-lifeline-config-temperature_lower']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">&deg;C</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              ECG
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="ST"
                value={pagePatient['patient-lifeline-config-ecg_st_msec']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">msec</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" sx={{ pb: 1 }}>
              Time Frame
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                style={{ border: 'none' }}
                variant="standard"
                label="Time Frame"
                value={pagePatient['patient-lifeline-config-time_frame']}
                InputProps={{
                  readOnly: true,
                  endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
                }}
              />
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
